import { TransactionStatus } from "@/services/cav-offline-sync/types";

export const statusConfig: Record<
  TransactionStatus,
  { label: string; className: string }
> = {
  pending: { label: "Pendente", className: "bg-yellow-100 text-yellow-800" },
  successful: {
    label: "Processado",
    className: "bg-green-100 text-green-800",
  },
  failed: { label: "Com Erro", className: "bg-red-100 text-red-800" },
};

export const columnDisplayNames: Record<string, string> = {
  store: "Loja",
  docCode: "Documento",
  register: "Caixa",
  nsu: "NSU",
  value: "Valor",
  terminalDate: "Data Terminal",
  status: "Status",
};
